/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SkillEfficacyMetrics = {
  averageScore: number;
  estimatedMinutesSavedAverage?: number | undefined;
  estimatedMinutesSavedSamples: number;
  estimatedMinutesSavedTotal: number;
  estimatedTurnsSavedAverage?: number | undefined;
  estimatedTurnsSavedSamples: number;
  estimatedTurnsSavedTotal: number;
  flagCounts: { [k: string]: number };
  roiConfidenceCounts: { [k: string]: number };
  scoredSessions: number;
};

/** @internal */
export const SkillEfficacyMetrics$inboundSchema: z.ZodMiniType<
  SkillEfficacyMetrics,
  unknown
> = z.pipe(
  z.object({
    average_score: z.number(),
    estimated_minutes_saved_average: z.optional(z.number()),
    estimated_minutes_saved_samples: z.int(),
    estimated_minutes_saved_total: z.number(),
    estimated_turns_saved_average: z.optional(z.number()),
    estimated_turns_saved_samples: z.int(),
    estimated_turns_saved_total: z.number(),
    flag_counts: z.record(z.string(), z.int()),
    roi_confidence_counts: z.record(z.string(), z.int()),
    scored_sessions: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "average_score": "averageScore",
      "estimated_minutes_saved_average": "estimatedMinutesSavedAverage",
      "estimated_minutes_saved_samples": "estimatedMinutesSavedSamples",
      "estimated_minutes_saved_total": "estimatedMinutesSavedTotal",
      "estimated_turns_saved_average": "estimatedTurnsSavedAverage",
      "estimated_turns_saved_samples": "estimatedTurnsSavedSamples",
      "estimated_turns_saved_total": "estimatedTurnsSavedTotal",
      "flag_counts": "flagCounts",
      "roi_confidence_counts": "roiConfidenceCounts",
      "scored_sessions": "scoredSessions",
    });
  }),
);

export function skillEfficacyMetricsFromJSON(
  jsonString: string,
): SafeParseResult<SkillEfficacyMetrics, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEfficacyMetrics$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEfficacyMetrics' from JSON`,
  );
}
